<template>
  <el-dialog :title="ActivityType ? '每日任务' : '活动任务'" :visible="true" width="1000px" center @close="dialogClose">
    <!-- 导航切换 -->
    <el-form :model="ruleForm" ref="ruleForm" class="backgroundForm" label-width="120px">
      <el-form-item label="任务分类:" required>
        <el-select v-model="ruleForm.taskType" placeholder="请选择" style="width: 500px;">
          <el-option v-for="item in options" :disabled="item.disabled" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务有效期:" required>
        <el-radio-group v-model="ruleForm.taskValidity" @change="handleChange">
          <el-radio :label="1">长期有效</el-radio>
          <el-radio :label="2">指定日期</el-radio>
        </el-radio-group>
        <div class="my_select_time" style="margin-left:21px" v-if="ruleForm.taskValidity === 2">
          <el-date-picker
            v-model="activityTimeValue"
            type="daterange"
            class="rangeTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptionsValue"
            ref="timeBox"
            style="width: 300px; font-size: 12px"
          >
          </el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
          <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item :label="ruleForm.taskType === 5 ? '跳转链接:' : '开卡链接:'" required v-if="ruleForm.taskType === 5 || ruleForm.taskType === 7">
        <el-input style="width:500px" v-model="ruleForm.jumpUrl" placeholder="请输入"></el-input>
        <div v-if="ruleForm.taskType === 5" style="line-height: 20px;color:#2670fb;margin-left: 0px;margin-top: 5px;">
          <span style="display: flex;align-items: center;"
            ><i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i> 注：跳转的链接必须为淘宝链接</span
          >
        </div>
      </el-form-item>
      <el-form-item label="加购商品数:" required v-if="ruleForm.taskType === 4">
        <el-input
          @input.native="checkputn"
          @input="(e) => (ruleForm.addCartLimit = validSe(e))"
          style="width:100px"
          v-model="ruleForm.addCartLimit"
          placeholder="请输入"
        ></el-input
        >&nbsp; 个
      </el-form-item>
      <el-form-item label="浏览时间:" required v-if="ruleForm.taskType === 3">
        <el-input
          @input.native="checkputn"
          @input="(e) => (ruleForm.viewTime = validSe(e))"
          style="width:100px"
          v-model="ruleForm.viewTime"
          placeholder="请输入"
        ></el-input
        >&nbsp; 秒
      </el-form-item>
      <el-form-item label="邀请人数上限:" required v-if="ruleForm.taskType === 8">
        <el-input
          @input.native="checkputn"
          @input="(e) => (ruleForm.inviteLimit = validSe(e))"
          style="width:100px"
          v-model="ruleForm.inviteLimit"
          placeholder="请输入"
        ></el-input
        >&nbsp; 人
      </el-form-item>
      <!-- <el-form-item label="任务说明:" required v-if="ruleForm.taskType === 8"> </el-form-item> -->
      <el-form-item label="任务说明:" required>
        {{ detailexplain(this.ruleForm.taskType) }}
      </el-form-item>
      <el-form-item :label="ruleForm.taskType === 3 ? '浏览商品:' : '加购商品:'" required v-if="ruleForm.taskType === 3 || ruleForm.taskType === 4">
        <el-button style="width: 155px; margin: 0 15px" @click="exposureProducts">
          {{ itemListFor.length != "" ? "指定商品" + "(" + itemListFor.length + "/30" + ")" : "选择商品" }}
        </el-button>
        <el-tooltip class="item" effect="light" style="color:#ccc !important" content="最多选择30个商品" placement="bottom">
          <el-button type="text" style="width: 35px;">
            <i class="el-icon-warning"></i>
          </el-button>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <div style="display:flex;align-items: self-end;">
      <div class="enter pointer" @click="handleEdit" v-if="ActivityIsAdd">
        确定
      </div>
      <div class="enter pointer" @click="handleConfirm" v-else>
        确定
      </div>
      <el-button style="width: 96px" @click="dialogClose">取消</el-button>
    </div>
    <!-- 添加曝光商品 -->
    <!-- <selectGoodsMonitor
      ref="selectGood"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :numlimit="30"
    ></selectGoodsMonitor> -->
    <selectGoodsMonitor v-if="selectGoodsState" @transferName="selectGoodsClose" :postForm="selectGoodsArr" :maxNum="30"> </selectGoodsMonitor>
  </el-dialog>
</template>

<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
export default {
  components: {
    selectGoodsMonitor,
  },
  props: {
    // true为每日活动 false任务
    ActivityType: {
      type: Boolean,
      default: false,
    },
    // disabledtask 禁用
    disabledtask: [],
    // false为新增 true修改
    ActivityIsAdd: {
      type: Boolean,
      default: false,
    },
    taskItem: {},
    // 活动日期
    timeDate: [],
  },
  data() {
    return {
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.timeDate.length != 0) {
            return time.getTime() < new Date(this.timeDate[0]).valueOf() - 8.64e7 || time.getTime() > new Date(this.timeDate[1]).valueOf();
          }
        },
      },
      activityTimeValue: [],
      selectGoodsState: false,
      ruleForm: {
        taskType: 1, //任务分类：1每日打卡 2浏览店铺 3浏览商品 4加购商品 5浏览会场 6关注店铺 7开卡入会 8好友助力
        taskValidity: 1, //任务有效期 ： 1长期有效 2指定日期
        startTime: "", //有效期开始时间
        endTime: "", //有效期结束时间
        viewTime: 30, //浏览时间
        skuIds: "", //商品id列表，多个用逗号隔开
        jumpUrl: "", //跳转链接
        inviteLimit: 5, //邀请人数上限
        addCartLimit: 5, //加购商品数
      },
      options: [],
      itemListFor: [],
      selectGoodsArr: [],
    };
  },
  async created() {
    if (this.ActivityType) {
      this.options = [
        {
          value: 1,
          label: "每日打卡",
          disabled: false,
        },
        {
          value: 2,
          label: "浏览店铺",
          disabled: false,
        },
        {
          value: 3,
          label: "浏览商品",
          disabled: false,
        },
        // {
        //   value: 4,
        //   label: "加购商品",
        //   disabled: false,
        // },
        {
          value: 5,
          label: "浏览会场",
          disabled: false,
        },
      ];
    } else {
      this.options = [
        {
          value: 6,
          label: "关注店铺",
          disabled: false,
        },
        {
          value: 7,
          label: "开卡入会",
          disabled: false,
        },
        {
          value: 8,
          label: "好友助力",
          disabled: false,
        },
      ];
    }

    this.disabledtask.forEach((i) => {
      this.options.forEach((item) => {
        if (i == item.value) {
          item.disabled = true;
        }
        // if (!item.disabled) this.ruleForm.taskType = item.value;
      });
    });
    if (this.disabledtask.length == 0) {
      this.ruleForm.taskType = this.options[0].value;
    } else {
      let arr = [];
      this.options.forEach((item) => {
        if (!item.disabled) {
          arr.push(item.value);
        }
      });
      this.ruleForm.taskType = arr[0];
    }
    if (this.ActivityIsAdd) {
      this.ruleForm = { ...this.ruleForm, ...this.taskItem };
      this.activityTimeValue = this.taskItem.taskValidity == 2 ? [this.taskItem.startTime, this.taskItem.endTime] : [];
      if (this.taskItem.itemList && this.taskItem.itemList.length != 0) {
        this.itemListFor = this.taskItem.itemList.map((item) => {
          return {
            ...item,
            numIid: item.wareId,
            itemTitle: item.title,
            picUrl: item.logo,
          };
        });
        this.selectGoodsArr = this.itemListFor;
      }
    }
  },
  methods: {
    detailexplain(type) {
      let content = "";
      if (type != 8) {
        content =
          type === 1
            ? "点击打卡"
            : type === 2
            ? "浏览店铺"
            : type === 3
            ? `浏览商品${this.ruleForm.viewTime ? this.ruleForm.viewTime : 0}秒`
            : type === 4
            ? `加购商品${this.ruleForm.addCartLimit ? this.ruleForm.addCartLimit : 0}个`
            : type === 5
            ? "浏览会场"
            : type === 6
            ? "点击关注"
            : "成功开卡";
        return content + ",赠送1次游戏机会";
      } else {
        return `每邀请1位好友，赠送1次游戏机会，最多可邀请${this.ruleForm.inviteLimit ? this.ruleForm.inviteLimit : 0}位助力`;
      }
    },
    // 指定日期
    handleChange(val) {
      console.log(val, !this.timeDate[0], !this.timeDate[1]);
      if ((val == 2 && !this.timeDate[0]) || !this.timeDate[1]) {
        this.$message.warning("需要先填写活动日期时间");
        return (this.ruleForm.taskValidity = 1);
      }
    },
    //输入框限制负数
    checkputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (num.quantityTotal && num.price && num.totalAmount) {
          let numTotal = this.$jingdouTotal({ ...num, prizeCount: num.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    dialogClose() {
      this.$emit("handleChoice");
    },
    handleConfirm() {
      let params = {
        activityType: this.ruleForm.taskType > 5 ? 2 : 1, //1为每日任务   2为活动任务
        taskType: this.ruleForm.taskType,
        taskValidity: this.ruleForm.taskValidity,
        startTime: this.activityTimeValue[0],
        endTime: this.activityTimeValue[1],
      };
      if (this.ruleForm.taskType == 3 || this.ruleForm.taskType == 4) {
        if (this.ruleForm.taskType == 3) params.viewTime = this.ruleForm.viewTime;
        if (this.ruleForm.taskType == 4) params.addCartLimit = this.ruleForm.addCartLimit;
        params.itemList = this.itemListFor;
        params.skuIds = this.itemListFor.map((item) => {
          return {
            wareId: item.numIid,
            skuId: item.numIid,
            title: item.title,
            logo: item.logo,
            price: item.price,
          };
        });
      }
      if (this.ruleForm.taskType == 8) params.inviteLimit = this.ruleForm.inviteLimit;
      if (this.ruleForm.taskType == 5 || this.ruleForm.taskType == 7) params.jumpUrl = this.ruleForm.jumpUrl;
      if (this.activityTimeValue.length === 0 && this.ruleForm.taskValidity === 2) {
        return this.$message.warning("请填写指定日期");
      }
      if ((this.ruleForm.taskType == 3 || this.ruleForm.taskType == 4) && this.itemListFor.length === 0) {
        return this.$message.warning("请选择商品");
      }
      if (this.ruleForm.taskType == 3 && !this.ruleForm.viewTime) {
        return this.$message.warning("请填写浏览时间");
      }
      if (this.ruleForm.taskType == 4 && !this.ruleForm.addCartLimit) {
        return this.$message.warning("请填写加购商品数");
      }
      if ((this.ruleForm.taskType == 5 || this.ruleForm.taskType == 7) && !this.ruleForm.jumpUrl) {
        return this.$message.warning(`请填写${this.ruleForm.taskType == 7 ? "开卡" : "跳转"}链接`);
      }
      if (this.ruleForm.taskType == 8 && !this.ruleForm.inviteLimit) {
        return this.$message.warning(`请填写邀请人数上限`);
      }
      if (this.ruleForm.taskType == 5 || this.ruleForm.taskType == 7) {
        let arr = ["taobao.com", "tmall.com", "jaeapp.com", "tmall.hk", "g.alicdn.com", "taobao.net", "tmall.net", "etao.com", "m.duanqu.com"];
        let jumpIsflay = false;
        arr.forEach((item) => {
          if (this.ruleForm.jumpUrl.indexOf(item) > -1) jumpIsflay = true;
        });
        if (!jumpIsflay) return this.$message.warning(`请输入淘宝链接判断`);
        // if (this.ruleForm.jumpUrl.indexOf("taobao.com") == -1 || this.ruleForm.jumpUrl.indexOf("jd.com") == -1) {
        //   //
        //   return this.$message.warning(`请输入淘宝域内链接`);
        // }
      }
      this.$emit("handleChoice", params);
    },
    handleEdit() {
      let params = {
        activityType: this.ruleForm.taskType > 5 ? 2 : 1, //1为每日任务   2为活动任务
        taskType: this.ruleForm.taskType,
        taskValidity: this.ruleForm.taskValidity,
        startTime: this.activityTimeValue[0],
        endTime: this.activityTimeValue[1],
      };
      if (this.ruleForm.taskType == 3 || this.ruleForm.taskType == 4) {
        if (this.ruleForm.taskType == 3) params.viewTime = this.ruleForm.viewTime;
        if (this.ruleForm.taskType == 4) params.addCartLimit = this.ruleForm.addCartLimit;
        params.itemList = this.itemListFor;
        params.skuIds = this.itemListFor.map((item) => {
          return {
            wareId: item.numIid,
            skuId: item.numIid,
            title: item.title,
            logo: item.logo,
            price: item.price,
          };
        });
      }
      if (this.ruleForm.taskType == 8) params.inviteLimit = this.ruleForm.inviteLimit;
      if (this.ruleForm.taskType == 5 || this.ruleForm.taskType == 7) params.jumpUrl = this.ruleForm.jumpUrl;
      if (this.activityTimeValue.length === 0 && this.ruleForm.taskValidity === 2) {
        return this.$message.warning("请填写指定日期");
      }
      if ((this.ruleForm.taskType == 3 || this.ruleForm.taskType == 4) && this.itemListFor.length === 0) {
        return this.$message.warning("请选择商品");
      }
      if (this.ruleForm.taskType == 3 && !this.ruleForm.viewTime) {
        return this.$message.warning("请填写浏览时间");
      }
      if (this.ruleForm.taskType == 4 && !this.ruleForm.addCartLimit) {
        return this.$message.warning("请填写加购商品数");
      }
      if ((this.ruleForm.taskType == 5 || this.ruleForm.taskType == 7) && !this.ruleForm.jumpUrl) {
        return this.$message.warning(`请填写${this.ruleForm.taskType == 7 ? "开卡" : "跳转"}链接`);
      }
      if (this.ruleForm.taskType == 8 && !this.ruleForm.inviteLimit) {
        return this.$message.warning(`请填写邀请人数上限`);
      }
      if (this.ruleForm.taskType == 5 || this.ruleForm.taskType == 7) {
        let arr = ["taobao.com", "tmall.com", "jaeapp.com", "tmall.hk", "g.alicdn.com", "taobao.net", "tmall.net", "etao.com", "m.duanqu.com"];
        let jumpIsflay = false;
        arr.forEach((item) => {
          if (this.ruleForm.jumpUrl.indexOf(item) > -1) jumpIsflay = true;
        });
        if (!jumpIsflay) return this.$message.warning(`请输入淘宝链接判断`);
        // if (this.ruleForm.jumpUrl.indexOf("http") == -1 || this.ruleForm.jumpUrl.indexOf("jd.com") == -1) {
        //   return this.$message.warning(`请输入淘宝链接判断`);
        // }
      }
      this.$emit("handleChoiceEdit", params);
    },
    // 加购商品
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        // event.forEach((item) => {
        //   newArr.push(item.numIid);
        // });
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      // if (data) {
      //   this.itemListFor = [];
      //   data.forEach((value, index) => {
      //     let fomeVaule = {};
      //     fomeVaule.skuId = data[index].skuId;
      //     fomeVaule.logo = data[index].logo;
      //     fomeVaule.price = data[index].jdPrice || data[index].price;
      //     fomeVaule.title = data[index].wareTitle || data[index].title;
      //     this.itemListFor.push(fomeVaule);
      //   });
      //   this.selectGoodsArr = this.itemListFor;
      // }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.selectGoodsArr = [];
      }
      // this.$refs.selectGood.handleRightCurrentChange(1);
    },
    validSe(data, type = 0) {
      // console.log("1111111", data);
      let filtered = data.replace(/[^\d]/g, "");
      if ((type = 0)) {
        if (Number(filtered) < 1) {
          filtered = "";
        }
      }
      return filtered;
    },
  },
};
</script>

<style lang="scss" scoped>
.zhuyi {
  margin-left: 18px;
  padding-left: 20px;
  // background: url("../../assets/images/new_icon_reminder.png") no-repeat;
  // background-position-y: 3px;
  // background-size: 14px 14px;
}
.enter {
  width: 104px;
  height: 32px;
  padding: 0 10px;
  background: #2670fb;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  margin-top: 26px;
  color: #ffffff;
  margin-left: 20px;
  margin-right: 20px;
  &:hover {
    opacity: 0.8;
  }
}
</style>
